module.exports = __webpack_public_path__ + "img/katarina_outside_5.9a3531f1.jpg";